import dayjs, { Dayjs } from "dayjs";
import { TFunction } from "i18next";

import { MAX_TIME_RANGE_MONTHS, MIN_TIME_RANGE_HOURS } from "../constants";
export interface ValidationResult {
    isValid: boolean;
    errorMessage?: string;
}

// 驗證開始時間是否晚於結束時間
export const validateStartBeforeEnd = (startTime: Dayjs, endTime: Dayjs, t: TFunction): ValidationResult => {
    if (startTime.isAfter(endTime)) {
        return {
            isValid: false,
            errorMessage: t("CH.Chat_History_Error_Start_After_End") || "開始時間不能晚於結束時間",
        };
    }
    return { isValid: true };
};

// 驗證日期範圍是否小於1小時
export const validateMinimumDuration = (startTime: Dayjs, endTime: Dayjs, t: TFunction): ValidationResult => {
    const diffInHours = endTime.diff(startTime, "hour", true);
    if (diffInHours < MIN_TIME_RANGE_HOURS) {
        return {
            isValid: false,
            errorMessage: t("CH.Chat_History_Error_Min_1_Hour") || "時間範圍至少需要 1 小時",
        };
    }
    return { isValid: true };
};

// 驗證日期範圍是否超過12個月
export const validateMaximumDuration = (startTime: Dayjs, endTime: Dayjs, t: TFunction): ValidationResult => {
    const diffInMonths = endTime.diff(startTime, "month", true);
    if (diffInMonths > MAX_TIME_RANGE_MONTHS) {
        return {
            isValid: false,
            errorMessage: t("CH.Chat_History_Error_Max_12_Months") || "時間範圍不能超過 12 個月",
        };
    }
    return { isValid: true };
};

// 驗證結束時間是否在未來
export const validateNoFutureDate = (endTime: Dayjs, t: TFunction): ValidationResult => {
    if (endTime.isAfter(dayjs())) {
        return {
            isValid: false,
            errorMessage: t("CH.Chat_History_Error_No_Future") || "不能查詢未來的時間",
        };
    }
    return { isValid: true };
};

// 驗證日期範圍
// 執行所有驗證檢查並回傳第一個錯誤
export const validateChatHistoryDateRange = (startTime: Dayjs, endTime: Dayjs, t: TFunction): ValidationResult => {
    // 按順序執行所有驗證
    const validations = [
        validateStartBeforeEnd(startTime, endTime, t),
        validateMinimumDuration(startTime, endTime, t),
        validateMaximumDuration(startTime, endTime, t),
        validateNoFutureDate(endTime, t),
    ];

    for (const validation of validations) {
        if (!validation.isValid) {
            return validation;
        }
    }

    return { isValid: true };
};
